
import {
  Button,
  Dropdown,
  Icon,
  List,
  Menu,
  Row,
  Col,
  Tag,
  Popconfirm,
} from "antd";
import { Typography } from "antd";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import ExpandableCard from "../general/ExpandableCard/ExpandableCard";
import { showSuccessToast, showErrorToast } from "../general/ToastHelper";
import history from "../../utils/history";
import { Translation } from "react-i18next";
import i18next from "i18next";
import { AccountGroupService } from "../../services/group/AccountGroupService";
import { handleError } from "../../utils/ErrorHandlers";
import { CfgAccountService } from "../../services/cfgAccount/CfgAccountService";
import { AccountService } from "../../services/account/AccountService";
import { el } from "date-fns/locale";
import { convertTZToUTCs } from "../general/DateTzHelper";
const { Text } = Typography;

class GroupAccountsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      showForm: false,
      groupAccount: null,
      showInnerCard: false,
      data: [],
    };
  }

  componentDidMount() {
    if (this.props.data) {
      let { data } = this.props;
      this.setState({ data });
    }
  }

  editgroupAccount(groupAccount) {
    history.push(`/home/groups/edit/${groupAccount}`);
  }

  viewGroupDetails(groupAccount) {
    history.push(`/home/groups/view/${groupAccount}`);
  }
  rendergroupAccountDropdown(groupAccount) {
    let menu = (
    
          <Menu>
            <Menu.Item
              onClick={() => this.editgroupAccount(groupAccount.groupId)}
            >
              {/* <Link to={`/edit/${groupAccount.groupAccountId}`}> */}
              <span>{i18next.t("Edit Group")}</span>
              <Icon className={"edit-account-style"} type="edit" />
              {/* </Link> */}
            </Menu.Item>
            <Menu.Item>
              <Popconfirm
                title={i18next.t("Are you sure delete this group?")}
                onConfirm={() => this.deletegroupAccount(groupAccount.groupId)}
                okText={i18next.t("Yes")}
                cancelText={i18next.t("No")}
              >
                <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                  {i18next.t("Delete Group")}
                  <Icon className={"delete-account-style"} type="delete" />
                </a>
              </Popconfirm>
            </Menu.Item>
            <Menu.Item
              onClick={() => this.viewGroupDetails(groupAccount.groupId)}
            >
              <span>{i18next.t("View Details")}</span>
              <Icon className={"view-details-style"} type="eye" />
            </Menu.Item>
          </Menu>
     
    );
    if (
      groupAccount.groupStatus == "INT" ||
      groupAccount.groupStatus == "SUS"
    ) {
      menu = (
    
            <Menu>
              <Menu.Item
                onClick={() => this.editgroupAccount(groupAccount.groupId)}
              >
                {/* <Link to={`/edit/${groupAccount.groupAccountId}`}> */}
                <span>{i18next.t("Edit Group")}</span>
                <Icon className={"edit-account-style"} type="edit" />
                {/* </Link> */}
              </Menu.Item>

              {groupAccount.cfg.call_flows != "" ||
              groupAccount.cfg.ready_flow != "None" ||
              groupAccount.groupType == "SXG" ? (
                <Menu.Item>
                  <Popconfirm
                    title={i18next.t("Are you sure activate this group?")}
                    onConfirm={() => this.activateGroupAccount(groupAccount)}
                    okText={i18next.t("Yes")}
                    cancelText={i18next.t("No")} >
                    <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                      {i18next.t("Activate Group")}
                      <Icon className={"edit-account-style"} type="check" />
                    </a>
                  </Popconfirm>
                </Menu.Item>
              ) : (
                <></>
              )}
              <Menu.Item>
                <Popconfirm
                  title={i18next.t("Are you sure delete this group?")}
                  onConfirm={() =>
                    this.deletegroupAccount(groupAccount.groupId)
                  }
                  okText={i18next.t("Yes")}
                  cancelText={i18next.t("No")}
                >
                  <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                    {i18next.t("Delete Group")}
                    <Icon className={"delete-account-style"} type="delete" />
                  </a>
                </Popconfirm>
              </Menu.Item>
              <Menu.Item
                onClick={() => this.viewGroupDetails(groupAccount.groupId)}
              >
                <span>{i18next.t("View Details")}</span>
                <Icon className={"view-details-style"} type="eye" />
              </Menu.Item>
            </Menu>
     
      );
    }

    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={groupAccount} type="more" />
        </Button>
      </Dropdown>
    );
  }

  async deletegroupAccount(groupAccount) {
    this.acc = new AccountGroupService();
    try {
      let data = await this.acc.deleteGroupAccount(
        this.props.context.session_id,
        groupAccount
      );
      showSuccessToast(i18next.t(data.statusMsg));
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }

  async getGroupByAccountIdAndGroupIdService(groupId) {
    this.acc = new AccountGroupService();
    try {
      let account = await this.acc.getGroupByAccountIdAndGroupIdService(
        this.props.context.session_id,
        groupId
      );
      return account;
    } catch (e) {
      throw e;
    }
  }

  async activateGroupAccount(groupAccount) {
    let account = await this.getGroupByAccountIdAndGroupIdService(
      groupAccount.groupId
    );

    let values = this.cfgMapper(account.ivrCustomEntityObject.cfg);

    let cfg = [];

    if (groupAccount.groupType == "IBG") {
      cfg = [
        {
          key: "MAX_CONCURRENT_CALLS",
          value: values.selectedNumberOfConcurrentCalls
            ? values.selectedNumberOfConcurrentCalls
            : "",
          configCategory: "CTI",
        },
        {
          key: "GROUP_NUMBERS",
          value: values.selectedValueGroupNumbers
            ? values.selectedValueGroupNumbers
            : "",
          configCategory: "CTI",
        },
        {
          key: "CALL_FLOW",
          value: values.selectedValueCallFlowId
            ? values.selectedValueCallFlowId
            : "",
          configCategory: "CTI",
        },
        {
          key: "READY_FLOW",
          value: values.selectedValueReadyFlow
            ? values.selectedValueReadyFlow
            : "",
          configCategory: "CTI",
        },
        {
          key: "ACTIVATE_VOICEMAIL",
          value: values.activateVoicemail,
          configCategory: "CTI",
        },
        {
          key: "START_WORKING_HOUR",
          value: values.startWorkingHour ? values.startWorkingHour : "",
          configCategory: "CTI",
        },
        {
          key: "END_WORKING_HOUR",
          value: values.endWorkingHour ? values.endWorkingHour : "",
          configCategory: "CTI",
        },
        {
          key: "VOICEMAIL_PROMPT",
          value: values.voiceMailMessage,
          configCategory: "CTI",
        },
        {
          key: "WORKING_DAYS",
          value: values.workingDays.toString(),
          configCategory: "CTI",
        },
        {
          key: "OLD_MAX_CONCURRENT_CALLS",
          value: values.selectedNumberOfConcurrentCalls,
          configCategory: "CTI",
        },
      ];
    }
    if (groupAccount.groupType == "SXG") {
      cfg = [
        {
          key: "SWITCH_MODE",
          value: values.selectedValueSM,
          configCategory: "CTI",
        },
        // {
        //   key: "AGENTS_NUMBERS",
        //   value: values.selectedAgentNumberForAgentGroup ? values.selectedAgentNumberForAgentGroup :"",
        //   configCategory: "CTI"
        // },
        // {
        //   key: "MAX_CONCURRENT_CALLS",
        //   value: values.selectedAgentNumberOfConcCalls
        //     ? values.selectedAgentNumberOfConcCalls
        //     : "0",
        //   configCategory: "CTI",
        // },
      ];
    }
    this.acc = new AccountGroupService();

    groupAccount.groupStatus = "ACT";

    try {
      let data = await this.acc.editGroupAccount(
        this.props.context.session_id,
        groupAccount,
        cfg
      );
      showSuccessToast(i18next.t(data.statusMsg));
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }

  handleRefresh() {
    this.setState({ isFetching: true });
    this.props.onRefresh();
  }
  showInnerCard(showInnerCard) {
    this.setState({ showInnerCard: !showInnerCard });
  }

  mapSwitchModes(mode) {
    switch (mode) {
      case "0":
        return "Round Robin";
      case "1":
        return "Most Idle Time";
      case "2":
        return "Least Received Calls";
      default:
        break;
    }
  }
  mapWorkingDays(items) {
    items = items.split(",");
    let days = [];
    items.forEach((index) => {
      switch (index) {
        case "0":
          days.push(i18next.t("Sunday"));
          break;
        case "1":
          days.push(i18next.t("Monday"));
          break;
        case "2":
          days.push(i18next.t("Tuesday"));
          break;
        case "3":
          days.push(i18next.t("Wednesday"));
          break;
        case "4":
          days.push(i18next.t("Thursday"));
          break;
        case "5":
          days.push(i18next.t("Friday"));
          break;
        case "6":
          days.push(i18next.t("Saturday"));
          break;
        default:
          break;
      }
    });

    return days.toString();
  }
  renderDetails(item) {
    return (
      <Translation>
        {(t) => (
          <Row>
            <Col xs={12}>
              <Text className="small-text">{t("Group Type")}</Text>
              <Tag className="m-2">
                {item.groupType === "IBG" ? t("Inbound") : null}
                {item.groupType === "SXG" ? t("AgentGroup") : null}{" "}
              </Tag>
            </Col>
            {item.groupType === "IBG" && (
              <Col xs={12}>
                <Text
                  className="small-text"
                  style={
                    this.props.context.curr_dir === "ltr"
                      ? { display: "unset", paddingRight: "5px" }
                      : { display: "unset", paddingLeft: "5px" }
                  }
                >
                  {t("Number Of Concurrent Calls")}
                </Text>
                <Tag className="m-2">{item.cfg.max_concurrent_calls}</Tag>
              </Col>
            )}
            <Col xs={12}>
              <Text className="small-text">{t("Group Name")}</Text>
              <Tag className="m-2">{item.groupName}</Tag>
            </Col>

            <Col xs={12}>
              <Text className="small-text">{t("Group Status")}</Text>
              <Tag className="m-2">{t(item.groupStatus)}</Tag>
            </Col>
            {item.groupType === "IBG" ? (
              <div>
                <Col xs={12}>
                  <Text className="small-text">{t("Call Flow")}</Text>
                  <Tag className="m-2">
                    {item.cfg.call_flows ? t(item.cfg.call_flows) : t("None")}
                  </Tag>
                </Col>
                <Col xs={12}>
                  <Text className="small-text">{t("Ready Flow")}</Text>
                  <Tag className="m-2">
                    {item.cfg.ready_flow === "None"
                      ? t("None")
                      : t(item.cfg.ready_flow)}
                  </Tag>
                </Col>
                <Col xs={12}>
                  <Text className="small-text">{t("Group Numbers")}</Text>

                  {item.cfg.group_numbers.map((tag, index) => {
                    return <Tag key={tag}>{tag}</Tag>;
                  })}
                </Col>
                {item.cfg.activate_voicemail === "true" ? (
                  <div>
                    <Col xs={12}>
                      <Text className="small-text">
                        {t("Activate VoiceMail")}
                      </Text>

                      <Tag className="m-2">
                        {item.cfg.activate_voicemail
                          ? t(item.cfg.activate_voicemail)
                          : t("false")}
                      </Tag>
                    </Col>

                    <Col xs={12}>
                      <Text
                        className="small-text"
                        style={
                          this.props.context.curr_dir === "ltr"
                            ? { display: "unset", paddingRight: "5px" }
                            : { display: "unset", paddingLeft: "5px" }
                        }
                      >
                        {t("Start Working Hour")}
                      </Text>

                      <Tag className="m-2">
                        {item.cfg.start_hour ? item.cfg.start_hour : "None"}
                      </Tag>
                    </Col>
                    <Col xs={12}>
                      <Text
                        className="small-text"
                        style={
                          this.props.context.curr_dir === "ltr"
                            ? { display: "unset", paddingRight: "5px" }
                            : { display: "unset", paddingLeft: "5px" }
                        }
                      >
                        {t("End Working Hour")}
                      </Text>

                      <Tag className="m-2">
                        {item.cfg.end_hour ? item.cfg.end_hour : "None"}
                      </Tag>
                    </Col>
                    <Col xs={12}>
                      <Text
                        className="small-text"
                        style={
                          this.props.context.curr_dir === "ltr"
                            ? { display: "unset", paddingRight: "5px" }
                            : { display: "unset", paddingLeft: "5px" }
                        }
                      >
                        {t("Working Days")}
                      </Text>

                      <Tag className="m-2">
                        {item.cfg.working_days
                          ? this.mapWorkingDays(item.cfg.working_days)
                          : "None"}
                      </Tag>
                    </Col>
                    <Col xs={12}>
                      <Text
                        className="small-text"
                        style={
                          this.props.context.curr_dir === "ltr"
                            ? { display: "unset", paddingRight: "5px" }
                            : { display: "unset", paddingLeft: "5px" }
                        }
                      >
                        {t("VoiceMail Message")}
                      </Text>

                      <Tag className="m-2">
                        {item.cfg.voicemail_message
                          ? item.cfg.voicemail_message
                          : "None"}
                      </Tag>
                    </Col>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <>
                <Col xs={12}>
                  <Text className="small-text">{t("Switch Mode")}</Text>
                  <Tag className="m-2">
                    {t(this.mapSwitchModes(item.cfg.switch_mode))}
                  </Tag>
                </Col>
              </>
            )}
          </Row>
        )}
      </Translation>
    );
  }
  render() {
    let { data } = this.props;
    return (
      <List
        dataSource={data}
        renderItem={(item) => {
          return (
            <ExpandableCard
              title={item.groupName}
              renderDropDown={this.rendergroupAccountDropdown(item)}
              content={item.id}
              renderDetails={this.renderDetails(item)}
              status={item.groupStatus}
            />
          );
        }}
      />
    );
  }

  cfgMapper(cfg) {
    let values = {
      selectedNumberOfConcurrentCalls: "",
      selectedValueCallFlowId: "",
    };

    cfg.forEach((element) => {
      if (
        Object.getOwnPropertyNames(element).indexOf("MAX_CONCURRENT_CALLS") > -1
      ) {
        values.selectedNumberOfConcurrentCalls =
          element["MAX_CONCURRENT_CALLS"];
      }
      if (Object.getOwnPropertyNames(element).indexOf("CALL_FLOW") > -1) {
        values.selectedValueCallFlowId = element["CALL_FLOW"];
      }
      if (Object.getOwnPropertyNames(element).indexOf("GROUP_NUMBERS") > -1) {
        values.selectedValueGroupNumbers = element["GROUP_NUMBERS"];
      }
      if (Object.getOwnPropertyNames(element).indexOf("SWITCH_MODE") > -1) {
        values.selectedValueSM = element["SWITCH_MODE"];
      }
      if (Object.getOwnPropertyNames(element).indexOf("READY_FLOW") > -1) {
        values.selectedValueReadyFlow = element["READY_FLOW"];
      }
      // if (Object.getOwnPropertyNames(element).indexOf("AGENTS_NUMBERS") > -1) {
      //   values.selectedAgentNumberForAgentGroup = element["AGENTS_NUMBERS"];
      // }
      if (
        Object.getOwnPropertyNames(element).indexOf("MAX_CONCURRENT_CALLS") > -1
      ) {
        values.selectedAgentNumberOfConcCalls = element["MAX_CONCURRENT_CALLS"];
      }
      if (
        Object.getOwnPropertyNames(element).indexOf("ACTIVATE_VOICEMAIL") > -1
      ) {
        values.activateVoicemail = element["ACTIVATE_VOICEMAIL"];
      }
      if (
        Object.getOwnPropertyNames(element).indexOf("END_WORKING_HOUR") > -1
      ) {
        values.endWorkingHour = element["END_WORKING_HOUR"];
      }
      if (
        Object.getOwnPropertyNames(element).indexOf("START_WORKING_HOUR") > -1
      ) {
        values.startWorkingHour = element["START_WORKING_HOUR"];
      }
      if (
        Object.getOwnPropertyNames(element).indexOf("VOICEMAIL_PROMPT") > -1
      ) {
        values.voiceMailMessage = element["VOICEMAIL_PROMPT"];
      }
      if (Object.getOwnPropertyNames(element).indexOf("WORKING_DAYS") > -1) {
        values.workingDays = element["WORKING_DAYS"];
      }
    });
    return values;
  }
}

export default withSharedStateConsumer(withRouter(GroupAccountsList));
